





document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function () {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    customProduct();
});
$(document).ready(function () {
    customProduct();
})
document.addEventListener('dkLabProductComparerProductsChanged', function () {
     $('.product').each(function () {
        $(this).find('.p-in').append($(this).find('.p-in-in .dkLabComparerProductDiv'))

     })
});


function customProduct() {
    $('.product').each(function () {
        $(this).find('.btn.btn-cart.add-to-cart-button span').text(translation('doKosiku'));
        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').prepend($(this).find('.price-standard'));
        }

        const $desc = $(this).find('.p-desc');
        const $code = $(this).find('.p-code');
        if ($desc.length) {
            $(this).find('.p-in-in').append($desc);
        }
        if ($code.length) {
            $(this).find('.p-in-in').append($code);
        }

        var energetickeFlagySelector = Object.keys(energetickeNarocnosti)
            .map(function (trida) { return '.' + energetickeNarocnosti[trida]; })
            .join(', ');

        var selectedFlag = $(this).find('.flags-default').find(energetickeFlagySelector).first();

        if (selectedFlag.length) {
            $(this).find('.ratings-wrapper').prepend(
                $('<div class="flagWrapper"></div>').append(selectedFlag.clone())
            );
        }




        // SMAZAT ->
    /*    if(!$(this).find('.customCompare').length){
            $(this).find('.p-bottom').after(`<div class="customCompare"><span>Přidat do porovnání</span></div>`);
        }*/
    });
}